import { useParams } from "react-router-dom";
import AssetView from "@/custolink-views/asset_frontend/asset_view/AssetView";

export default function AssetCustomView() {
  const { viewUiSlug, viewValue } = useParams();

  return (
    <AssetView
      serialNumber={""}
      customAssetView={{
        urlSlug: viewUiSlug ?? "",
        assetAttrValue: viewValue ?? "",
      }}
    />
  );
}

